
















































































import {Component, Prop, Watch} from "vue-property-decorator";
import bus from "@/main";
import {Api} from "@/core/services/MedicaPro/Api";
import {Prescription} from "@/core/services/MedicaPro/models";
import BaseComponent from "@/core/components/BaseComponent";
import MedicinePicker from "@/components/Admin/Settings/Medicines/Picker/MedicinePicker.vue";

@Component({
    components: {MedicinePicker}
})
export default class PrescriptionItemEdit extends BaseComponent {

    // Bindings to parent
    @Prop() item?: Prescription | null;

    // Bindings to view
    public dialog = false;
    public valid = false;
    public rules = {
        name: [(v: any) => !!v || 'Name is required'],
    }
    public dosageUnits = [
        {
            value: 'mg',
            name: 'Milligram',
        },
        {
            value: 'μg',
            name: 'Mikrogram',
        },
        {
            value: 'mL',
            name: 'Milliliter',
        },
    ];
    public dailyDosageUnits = [
        {
            value: 'pieces',
            name: 'Stk.',
        },
    ];

    public mounted() {
        this.loadItem();
    }

    public save() {
        if (this.valid) {
            const API = this.item?.exists() ? Api.prescriptions().patchById(this.item.id!) : Api.prescriptions().post();
            API.save(this.item!, item => {
                this.close();
                this.$toast(`Medicin gemt`, {
                    color: 'green',
                    dismissable: true
                });
                bus.$emit('prescriptionSaved', item);
            });
        }
    }

    public close() {
        this.dialog = false;
        this.isReady = false;
    }

    @Watch('item')
    private loadItem() {
        if (this.item == null) {
            // Ignore
        } else {
            this.renderView();
            this.dialog = true;
        }
    }

    private renderView() {
        this.isReady = true;
    }

}
